export default __webpack_public_path__ + "static/cm-a6f12f1216e9df8ea739c40a54c67c2d.png";